import { OptionModel } from '../../types';

export const sortOptionsByDuration = (options: OptionModel[], ascending = true): OptionModel[] => {
  return [...options].sort((a, b) => {
    const aDuration = a.totalDurationSeconds;
    const bDuration = b.totalDurationSeconds;
    return ascending ? aDuration - bDuration : bDuration - aDuration;
  });
};
